import type { PersonGeneral } from '@quromedical/models';
import { Breadcrumb } from 'components/fhir';
import { getNameAgeAndGender } from 'core/display';
import { useIsSmallerThan } from 'hooks/useResponsive';
import type React from 'react';
import { strings } from 'strings';

interface PatientBreadcrumbProps {
  id: string;
  patient?: Partial<PersonGeneral>;
}

/**
 * Will display a `Breadcrumb` that links to the patient list. Only visible on small devices
 */
export const PatientBreadcrumb: React.FC<PatientBreadcrumbProps> = ({
  id,
  patient,
}) => {
  const isSmall = useIsSmallerThan('lg');
  const patientDisplay = getNameAgeAndGender(patient);

  if (isSmall) {
    return null;
  }

  // Define Expo Router paths
  const patientListPath = '/patient/patients';
  const patientProfilePath = `/patient/${id}/profile`;

  return (
    <Breadcrumb
      links={[
        {
          text: strings.MyPatients,
          to: patientListPath,
        },
        {
          text: patientDisplay,
          to: patientProfilePath,
        },
      ]}
    />
  );
};
